export const breadcrumbMapArr = [
  {
    name: "PT+ Admin",
    link: "ptplus-user-managememt",
    eventType: "",
  },
];

export const headerArr = [
  { title: 'Customer Name' },
  { title: 'Location Name' },
  { title: 'Address' },
  { title: 'City' },
  { title: 'State' }
];

export const listingRawData = [
  {
    "customerName": "123 Inc",
    "locationName": "Warehouse B",
    "city": "Chicago",
    "state": "New York",
    "feeItems": [
      {
        "vendorName": "PQR Distributors",
        "palletType": "Grade A",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      },
      {
        "vendorName": "Test",
        "palletType": "Grade B",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      }
    ]

  },
  {
    "customerName": "XYZ Corp",
    "locationName": "Distribution Center 1",
    "city": "Los Angeles",
    "state": "California",
    "feeItems": [
      {
        "vendorName": "LMN Logistics",
        "palletType": "Grade A",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      },
      {
        "vendorName": "LMN Testing",
        "palletType": "Grade B",
        "customerPrice": 15.25,
        "vendorPrice": 14.00,
        "startDate": "04/11/2024",
        "endDate": "04/24/2024",
        "comment": "Negotiated pricing"
      }
    ]

  }
]

export const palletTypeOptions = [
  {
    "label": "Grade A",
    "value": "GRADE_A_48x40"
  },
  {
    "label": "Grade A1",
    "value": "GRADE_A1_48x40"
  },
  {
    "label": "Grade B",
    "value": "GRADE_B_48x40"
  },
  {
    "label": "Odd",
    "value": "ODD"
  },
  {
    "label": "Scrap",
    "value": "SCRAP"
  },
]

